import { render, staticRenderFns } from "./PropertyListRow.vue?vue&type=template&id=85799eb2&"
import script from "./PropertyListRow.vue?vue&type=script&lang=ts&"
export * from "./PropertyListRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports